import template from './addressLookupClient.html';
import controller from './addressLookupClientCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    address: '<',
  },
};
